import { render, staticRenderFns } from "./InformativeFlatRoof.vue?vue&type=template&id=230057c2&scoped=true"
import script from "./InformativeFlatRoof.vue?vue&type=script&lang=js"
export * from "./InformativeFlatRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230057c2",
  null
  
)

export default component.exports